/**
 * Created by Karol Kluska on 21.06.17.
 */

angular
  .module('app')
  .component('offersPanelCategory', {
    templateUrl: 'app/components/offers/panel/category/Category.html',
    controller: PanelCategory,
    bindings: {
      categoryId: '<',
      onClick: '&'
    }
  });

function PanelCategory(PanelObserver, Categories) {
  var $this = this;
  $this.PanelObserver = PanelObserver;
  $this.isOpen = false;
  $this.categories = Categories.getCategories();
}

PanelCategory.prototype = {
  $onInit: function () {
    if (!angular.isArray(this.categories)) {
      this.categories = [];
    }
    this.category = this.findCategoryById(this.categoryId);
    this.PanelObserver.setCategoryId(this.category.id);
  },

  $onChanges: function () {
    this.PanelObserver.setCategoryId(null);
  },

  handleClick: function () {
    this.onClick();
  },

  handleChange: function () {
    this.PanelObserver.setCategoryId(this.category.id);
  },

  setCategory: function (category) {
    this.category = category;
    this.handleChange();
  },

  findCategoryById: function (categoryId) {
    var category = this.categories.find(function (category) {
      return category.id === categoryId;
    });
    if (angular.isObject(category)) {
      return category;
    }
    return this.categories[0];
  }
};
